import React, { useEffect } from "react";
import ProductCarousel from "../components/home/HomeSwiper";
import HomeReview from "../components/home/HomeReview";
import Combine from "../components/home/Combine";
import HomeQuality from "../components/home/HomeQuality";
import HomeBottom from "../components/home/HomeBottom";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div>
      <Combine />
      <ProductCarousel />
      <HomeReview />
      <HomeQuality />
      <HomeBottom />
    </div>
  );
};

export default HomePage;
